import { render, staticRenderFns } from "./itinerary_air_5.vue?vue&type=template&id=1765bd42&"
import script from "./itinerary_air_5.vue?vue&type=script&lang=js&"
export * from "./itinerary_air_5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/deploy/beta-web-new/web_head/releases/20260305082618/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1765bd42')) {
      api.createRecord('1765bd42', component.options)
    } else {
      api.reload('1765bd42', component.options)
    }
    module.hot.accept("./itinerary_air_5.vue?vue&type=template&id=1765bd42&", function () {
      api.rerender('1765bd42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/desktop/itineraries/itinerary_air_5.vue"
export default component.exports